const apiBaseUrl = process.env.VUE_APP_API
const appName = process.env.VUE_APP_NAME
export { apiBaseUrl, appName }
